import type { UserInfo } from '@nf/types/account';
import { AccountActStatus } from '@nf/utils-common/constants';

export const isWcVipProgramBaseEligible = ({
	authToken,
	enableVipProgramHint,
	user,
}: {
	authToken: string | null | undefined;
	enableVipProgramHint: boolean | undefined;
	user: UserInfo | null | undefined;
}): boolean =>
	Boolean(
		authToken &&
			enableVipProgramHint &&
			(user?.CC === 2026) &&
			user?.ActStatus === AccountActStatus.Deposited
	);
